// extracted by mini-css-extract-plugin
export default {"wrap":"Bs-z","fullWidth":"Cs-z","items":"Ds-z","featureCss":"Es-z","disabled":"Fs-z","imgCss":"Gs-z"};